import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Crane.css';
import { updatePageSEO, addStructuredData } from '../utils/SeoUtils';

// Guindaste equipment data
const guindasteEquipment = [
  {
    name: 'GUINDASTE 70 TONELADAS',
    specs: 'Modelo TEREX LT1070 - 59 metros de lança',
    slug: 'guindaste-70-toneladas',
    image: '/images/equip/guindaste/guindaste70.png',
    graficos: [
      '/images/equip/guindaste/grafico/guindaste70_g1.png',
      '/images/equip/guindaste/grafico/guindaste70_g2.png',
      '/images/equip/guindaste/grafico/guindaste70_g3.png',
    ],
  },
  {
    name: 'GUINDASTE 90 TONELADAS ZOOMLION',
    specs: 'Modelo ZOOMLION ZMC900V5 - 65 metros de lança',
    slug: 'guindaste-90-toneladas-zoomlion',
    image: '/images/equip/guindaste/guindaste90_zoomlion.png',
    graficos: [
      '/images/equip/guindaste/grafico/guindaste90_zoomlion_g1.png',
      '/images/equip/guindaste/grafico/guindaste90_zoomlion_g2.png',
      '/images/equip/guindaste/grafico/guindaste90_zoomlion_g3.png',
    ],
  },
  {
    name: 'GUINDASTE 90 TONELADAS SANY',
    specs: 'Modelo SANY STC900T5 - 76,5 metros de lança',
    slug: 'guindaste-90-toneladas-sany',
    image: '/images/equip/guindaste/guindaste90_sany.png',
    graficos: [
      '/images/equip/guindaste/grafico/guindaste90_sany_g1.png',
      '/images/equip/guindaste/grafico/guindaste90_sany_g2.png',
    ],
  },
];

function Crane() {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Update SEO for Guindaste page
    updatePageSEO(
      'Locação de Guindaste em Rondonópolis - MEGATON',
      'Aluguel de guindastes de grande porte em Rondonópolis. Guindastes de 70 e 90 toneladas para projetos industriais e construção pesada.',
      'guindaste, locação guindaste, aluguel guindaste, rondonópolis, guindastes industriais, içamento pesado'
    );

    // Add structured data for guindaste listing
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'Locação de Guindaste - MEGATON Rondonópolis',
      description:
        'Guindastes de grande porte para operações industriais e projetos complexos em Rondonópolis',
      itemListElement: guindasteEquipment.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: item.name,
          description: item.specs,
          image: `https://megatonguindastes.com.br${item.image}`,
          url: `https://megatonguindastes.com.br/guindaste/${item.slug}`,
          category: 'Guindaste',
          brand: {
            '@type': 'Brand',
            name: 'MEGATON',
          },
        },
      })),
    };

    addStructuredData(structuredData);
  }, []);

  return (
    <div className="equipment">
      <section className="equipment-section">
        <div className="container">
          <h2 className="section-title">Guindaste</h2>
          <div className="equipment-cards">
            {guindasteEquipment.map((item, index) => (
              <div key={index} className="equipment-card">
                <Link to={`/guindaste/${item.slug}`} className="equipment-image-link">
                  <div className="equipment-image">
                    <img
                      src={item.image}
                      alt={item.name + ' em Rondonópolis, MT - Locação de Guindaste MEGATON'}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </Link>
                <div className="equipment-info">
                  <h3>{item.name}</h3>
                  <p className="equipment-specs">{item.specs}</p>
                  <Link to={`/guindaste/${item.slug}`} className="details-btn">
                    Ver detalhes
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="equipment-features">
        <div className="container">
          <h2>Vantagens dos Nossos Guindastes</h2>
          <div className="features-grid">
            <div className="feature-item">
              <h4>🏗️ Grande Capacidade</h4>
              <p>Guindastes de 70 a 90 toneladas para os projetos mais exigentes</p>
            </div>
            <div className="feature-item">
              <h4>📏 Longo Alcance</h4>
              <p>Lanças de até 76,5 metros para operações de grande altura</p>
            </div>
            <div className="feature-item">
              <h4>🔧 Tecnologia Avançada</h4>
              <p>Equipamentos modernos com sistemas de controle e segurança avançados</p>
            </div>
            <div className="feature-item">
              <h4>🚀 Projetos Complexos</h4>
              <p>Especialistas em operações industriais e construção pesada</p>
            </div>
          </div>
        </div>
      </section>

      <section className="equipment-applications">
        <div className="container">
          <h2>Aplicações para Guindastes</h2>
          <div className="applications-grid">
            <div className="application">
              <h4>Construção Pesada</h4>
              <ul>
                <li>Montagem de estruturas metálicas</li>
                <li>Instalação de vigas e pilares</li>
                <li>Construção de edifícios altos</li>
                <li>Montagem de torres e antenas</li>
              </ul>
            </div>
            <div className="application">
              <h4>Indústria Petroquímica</h4>
              <ul>
                <li>Instalação de equipamentos pesados</li>
                <li>Manutenção de refinarias</li>
                <li>Montagem de torres de processo</li>
                <li>Movimentação de tanques</li>
              </ul>
            </div>
            <div className="application">
              <h4>Energia e Infraestrutura</h4>
              <ul>
                <li>Instalação de aerogeradores</li>
                <li>Montagem de subestações</li>
                <li>Construção de pontes</li>
                <li>Instalação de torres de transmissão</li>
              </ul>
            </div>
            <div className="application">
              <h4>Projetos Especiais</h4>
              <ul>
                <li>Operações de resgate</li>
                <li>Instalações portuárias</li>
                <li>Projetos offshore</li>
                <li>Emergências industriais</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 
      <section className="guindaste-specs">
        <div className="container">
          <h2>Especificações dos Guindastes</h2>
          <div className="specs-comparison">
            <div className="spec-card">
              <h4>TEREX 70 TON</h4>
              <ul>
                <li><strong>Capacidade:</strong> 70 toneladas</li>
                <li><strong>Lança:</strong> 59 metros</li>
                <li><strong>Altura max:</strong> 59m</li>
                <li><strong>Raio max:</strong> 56m</li>
              </ul>
            </div>
            <div className="spec-card">
              <h4>ZOOMLION 90 TON</h4>
              <ul>
                <li><strong>Capacidade:</strong> 90 toneladas</li>
                <li><strong>Lança:</strong> 65 metros</li>
                <li><strong>Altura max:</strong> 65m</li>
                <li><strong>Raio max:</strong> 62m</li>
              </ul>
            </div>
            <div className="spec-card">
              <h4>SANY 90 TON</h4>
              <ul>
                <li><strong>Capacidade:</strong> 90 toneladas</li>
                <li><strong>Lança:</strong> 76,5 metros</li>
                <li><strong>Altura max:</strong> 76,5m</li>
                <li><strong>Raio max:</strong> 72m</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      */}

      <section className="cta-section">
        <div className="container">
          <h2>Precisa de um Guindaste?</h2>
          <p>Consulte nossos especialistas para projetos industriais e de grande porte</p>
          <Link to="/contato" className="cta-btn">
            Solicitar Orçamento
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Crane;
